import React from "react";
import "./OfferPage.css";

import cabservies from "../../assets/cabservice.png";
import bikerental from "../../assets/bikerental.png";
import carrental from "../../assets/carrental.png";
import { Link } from "react-router-dom";

const OfferPage = () => {
  return (
    <div className="offer-section">
      <div className="offer-header">
        <h2>What We Offer</h2>
        <p>Premium services tailored to your travel needs</p>
      </div>

      <div className="offer-container">
      
          {" "}
        <div className="offer-card">
            <Link to="/offer-cab-service-data" className="offer-link">
            <img src={cabservies} alt="cab service" />
          <h3>Cab Services</h3>
           </Link>
          </div>
       

        
          
        <div className="offer-card">
          <Link to="/offer-bike-rental-data" className="offer-link">
            <img src={bikerental} alt="bike rental" />
          <h3>Bike Rental</h3>
            </Link>
          </div>
      

       
        <div className="offer-card">
           <Link to="/offer-car-rental-data" className="offer-link">
            <img src={carrental} alt="car rental" />
          <h3>Car Rental</h3>
           </Link>
          </div>
       
      </div>
    </div>
  );
};

export default OfferPage;
